<template>
  <div v-loading="loading">
    <div style="display:flex;justify-content:space-between;align-items:center">
      <div>当前节点：{{ curNode.NAME_?curNode.NAME_:'-' }}</div>
      <div>跳转节点：
        <el-select
          v-model="jumpNodeValue"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in nodeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>
    <div
      v-if="needUser"
      style="margin-top:20px"
    >
      <sw-tip
        text="该跳转节点需要审批指定，请选择审批人"
        type="primary"
      />
      <User @change="handleChange" />
    </div>
  </div>
</template>

<script>
import service from '@/utils/service.js'
import User from './selectUser.vue'
export default {
  components: {
    User
  },
  props: {
    taskid: {
      type: String,
      default: ''
    },
    curNode: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      nodeList: [],
      loading: true,
      jumpNodeValue: '',
      userId: ''
    }
  },
  computed: {
    needUser () {
      const node = this.nodeList.filter((item) => {
        return item.value === this.jumpNodeValue
      })
      if (!node.length) {
        return false
      }
      return node[0].label.indexOf('审批指定') > -1
    }

  },
  watch: {
    curNode: {
      handler: function () {
        this.userId = ''
        this.jumpNodeValue = ''
        this.getOtherNode()
      },
      immediate: true
    }
  },
  methods: {
    handleChange (user) {
      this.userId = user.id
    },
    getOtherNode () {
      const params = {
        processId: this.curNode.act_process_id
      }
      this.loading = true
      service.get('/v1/intervene/otherNode', { params }).then(res => {
        this.nodeList = res.josnObj.node.map((item) => {
          item.label = (item.name || '暂无名称') + (item.approval === 'yes' ? '(审批指定)' : '')
          item.value = item.id
          return item
        })
        this.loading = false
      }).catch(err => {
        this.$swMessage({
          message: '获取当前节点办理人失败，请稍后再试' + err.message,
          type: 'error'
        })
      })
    }
  }
}
</script>

<style>
</style>
